import { AxiosService } from './axios.service'

const baseURL = 'passageiro'

/**
 * Defines the API methods for an user ticket
 */
export class PassengerService {
	/**
	 * Gets the list of passengers
	 * @return {Promise<any[]>} lista de passageiros
	 */
	static getPassengers() {
        return AxiosService.get(`${baseURL}/listar`)
        .then(({ data }) => data)
		.catch(() => [])
	}	

	/**
	 * Delete the passenger of user
	 * @return {Promise<any[]>} delete the passenger
	 */
	static deletePassenger(idPassenger) {
        return AxiosService.post(`${baseURL}/remover`, {idPassenger})
        .then(({ data }) => data)
		.catch(() => [])
	}	

	/**
	 * Add a passenger of user
	 * @return {Promise<any[]>} Add a passenger
	 */
	static addPassenger(passenger) {
        return AxiosService.post(`${baseURL}/adicionar`, passenger)
        .then(({ data }) => data)
		.catch(() => [])
	}	
}
